export default __webpack_public_path__ + "static/media/contrafa.f465f064.png";